import {
  PartFinderCatalogPage,
  PartFinderFamilySearchPage,
  PartFinderReelResultsPage,
} from 'partFinder/pages';

import {
  partFinderCatalogPath,
  partFinderFamilyPartsPath,
  partFinderFamilyPath,
} from './routePaths';

const partFinderCatalog = {
  path: partFinderCatalogPath(),
  exact: true,
  isPrivate: true,
  element: <PartFinderCatalogPage />,
};

const partFinderFamily = {
  path: partFinderFamilyPath(),
  exact: true,
  isPrivate: true,
  element: <PartFinderFamilySearchPage />,
};

const partFinderFamilyParts = {
  path: partFinderFamilyPartsPath(),
  exact: true,
  isPrivate: true,
  element: <PartFinderReelResultsPage />,
};

export const partFinderRoutes = [partFinderCatalog, partFinderFamily, partFinderFamilyParts];
